import _ from "lodash";
import { colors, createMuiTheme, responsiveFontSizes } from "@material-ui/core";
import typography from "./typography";

const baseOptions = {
  typography,
  overrides: {
    // Mui: {
    //   selected: { borderRadius: "50px" },
    // },
    PrivateTabIndicator: {
      colorSecondary: {
        height: "0",
      },
    },
    MuiLinearProgress: {
      root: {
        borderRadius: 3,
        overflow: "hidden",
      },
      colorSecondary: {
        height: "17px",
        backgroundColor: "#F1F1F1",
        borderRadius: "17px",
      },
      barColorSecondary: {
        backgroundColor: "#FABC12",
        borderRadius: "30px",
      },
      colorPrimary: {
        height: "17px",
        backgroundColor: "#F1F1F1",
        borderRadius: "30px",
      },
      barColorPrimary: {
        background: "linear-gradient(90deg, lightcoral 50%, orange 100%)",
        borderRadius: "30px",
      },
    },
    MuiListItemIcon: {
      root: {
        minWidth: 32,
      },
    },
    MuiChip: {
      root: {
        backgroundColor: "rgba(0,0,0,0.075)",
      },
    },
    MuiListItemText: {
      multiline: {
        fontWeight: "bold",
        fontSize: "36px",
        lineHeight: "44px",
        color: "#000000",
      },
    },
    MuiOutlinedInput: {
      root: {
        borderRadius: 50,
        color: "#fff",
        height: "56px",
        paddingLeft: "30px",
      },
      notchedOutline: {
        border: "2px solid #fff",
        borderColor: "#fff",
        paddingLeft: "30px",
      },
    },
    MuiTab: {
      wrapper: {
        fontWeight: 600,
        fontSize: "22px",
        lineHeight: "42px",
        padding: "0 20px",
        textAlign: "center",
        color: "#000000",
        fontFamily: "'Montserrat', sans-serif",
        "@media(max-width:991px)": {
          fontSize: "18px",
        },
      },
    },
    MuiAppBar: {
      colorPrimary: {
        border: "1.5px solid #FABC12",
        borderRadius: "50px",
        backgroundColor: "#fff",
        maxWidth: "fit-content",
        margin: "0 auto",
        width: "700px",
        minWidth: "700px",
      },
      //       {
      //         background: "#FABC12",
      // borderRadius: "50px",
      //       }
    },
    MuiInputLabel: {
      outlined: {
        transform: "translate(14px, 10px) scale(1)",
        fontSize: "20px",
        paddingLeft: "30px",
        lineHeight: "37px",
        color: "#fff",
        fontWeight: "600",
      },
    },
    MuiButton: {
      contained: {
        boxShadow: "none",
        borderRadius: 5,
        "&:hover": {
          boxShadow: "none",
        },
      },
      containedPrimary: {
        '&:hover': {
          backgroundColor: "#ff9638",
          color: "rgb(255 207 144)",
          border: "2px solid rgb(255 207 144)"
        },
        padding: "0.7em 2.5em",
        border: "2px solid rgb(242 86 39)",
        borderRadius: "1em",
        fontSize: "19px",
        color: "rgb(242 86 39)",
        backgroundColor: "rgb(255 207 144)",
        transformStyle: "preserve-3d",
        transition: "all 175ms cubic-bezier(0, 0, 1, 1)",
        "@media(max-width:991px)": {
          fontSize: "14px",
          padding: "0.7em 0.5em",
        },
      },
      


      outlined: {
        boxShadow: "none",
        borderRadius: 27,
        borderWidth: 2,
      },
      outlinedPrimary: {
        borderRadius: 27,
        boxShadow: "none",
      },
      containedSizeLarge: {
        color: "#ffffff",
        padding: "14px 50px",
      },
      containedSizeSmall: {
        borderRadius: "50px",
        backgroundColor: "#fff",
        padding: "4px 45px 4px 45px ",
        height: "56px",
        fontSize: "20px",
        maxWidth: "250px",
        whiteSpace: "nowrap",
        lineHeight: "37px",
        color: "#FABC12",
        fontWeight: "600",
        "@media (max-width: 767px)": {
          fontSize: "25px",
          lineHeight: "30px",
        },
        "&:hover": {
          backgroundColor: "#f5f5f5",
        },
      },
      containedSecondary: {
        borderRadius: "50px",
        backgroundColor: "#fff",
        padding: "4px 45px 4px 14px ",
        height: "100px",
        fontSize: "30px",
        lineHeight: "37px",
        color: "#FF8316",
        fontWeight: "600",
        "@media (max-width: 767px)": {
          fontSize: "17px",
          padding: "4px 25px 4px 8px ",
          height: "50px",
          lineHeight: "20px",
        },
        "&:hover": {
          backgroundColor: "#f5f5f5",
        },
      },
    },
  },
};

const themesOptions = {
  typography: {
    fontWeight: 400,
    fontFamily: "'Montserrat', sans-serif",
  },
  palette: {
    type: "light",
    action: {
      primary: "#20509e",
    },
    background: {
      default: "#FBFBFDred",
      dark: "#f3f7f9",
      paper: colors.common.white,
    },
    primary: {
      main: "#ff9638",
      dark: "#202831",
      light: "#e2e3fa",
    },
    secondary: {
      main: "#ff0610",
    },
    warning: {
      main: "#ffae33",
      dark: "#ffae33",
      light: "#fff1dc",
    },
    success: {
      main: "#54e18c",
      dark: "#54e18c",
      light: "#e2faec",
    },
    error: {
      main: "#ff7d68",
      dark: "#ff7d68",
      light: "#ffe9e6",
    },
    text: {
      primary: "#52565c",
      secondary: "#999999",
    },
    common: {
      black: "#222222",
    },
  },
};

export const createTheme = (config = {}) => {
  let theme = createMuiTheme(_.merge({}, baseOptions, themesOptions));

  if (config.responsiveFontSizes) {
    theme = responsiveFontSizes(theme);
  }

  return theme;
};
